import React, { useState, useEffect, useCallback } from 'react'

import {
  Tab,
  Button,
  Row,
  Col,
} from 'components'
import { useAuth, useFile, useModal, useLoading, useException } from 'hooks'
import { PERMITIONS } from 'permitions'
import { MovimentacaoMensalServices } from 'services/Supplier/MovMensal'
import { ManuaisFornecedorService } from 'services/Generic/Generic'
import { FORMAT, SPACING } from 'utils'

import {
  MovimentacaoMensal,
  PesquisaMovAnalista,
  PesquisaMovFornecedor
} from './components'
import MovMensalProvider from './context/MovMensalContext/MovMensalContext'
import { ResponseGetParametrizacaoEfeitvo } from './types'
import { reportsDatabase } from 'services/database/reportsDatabase'

const MovMensal: React.FC = () => {
  const { downloadFile } = useFile()
  const { getException, createCustomException } = useException()
  const { allDatadescripted, user } = useAuth() //PEGA PERFIL DESSE OBJ
  const { setLoading } = useLoading()
  const { showModal } = useModal()
  const [selectedModalID, setSelectedModalID] = useState(0);

  const [tabs, setTabs] = useState<string[]>(['Pesquisar'])
  const [parametrizacoes, setParametrizacoes] = useState<
    ResponseGetParametrizacaoEfeitvo | undefined
  >(null)
  const [selectedTab, setSelectedTab] = useState<number>(0)
  const [pesquisaMovFornecedorExpanded, setPesquisaMovFornecedorExpanded] = useState<{ id: number }[]>([])

  const handleChange = (_, newValue) => {
    //QUANDO USUARIO TROCAR DE TAB
    if (newValue === 0 && tabs.length > 1) {
      //CRIAR COPIA DA LISTA TABS
      //RETIRAR A ULTIMA
      const cpy = tabs.slice()
      cpy.pop()
      setTabs(cpy)
    }
    setSelectedTab(newValue)
  }

  const handleNewTab = (newValue: string) => {
    if (tabs.length > 2) {
      const cpy = tabs.slice()
      cpy.pop()
      cpy.push(newValue)
      setTabs(cpy)

      setTabs((prevState) => [...prevState.slice(0, -1), newValue])
    }

    setTabs((old) => [...old, newValue])
    handleChange(null, 1)
  }

  const handleCompetencia = (competencia: string) => {
    handleNewTab(FORMAT.competencia(competencia))
  }

  const getDadosParametrizacao = () => {
    setLoading('loading')

    MovimentacaoMensalServices()
      .getDadosParametrizacao()
      .then((response) => {
        if (response.status !== 200) {
          throw new Error('Não foi possível obter os dados da parametrização')
        }

        setParametrizacoes(response.data[0])
      })
      .catch((error) => {
        setLoading('idle')
        showModal({
          hideButtonCancel: true,
          message: 'Não foi possivel obter o dados da pesquisa',
          txtButtonConfirm: 'OK',
          type: 'error'
        })
      })
  }

  const handleDownloadOrientacaoFornecedor = () => {
    setLoading('loading')

    ManuaisFornecedorService()
      .getManual('Orientacao-Geral-Movimentacao-de-colaboradores.pdf')
      .then(response => {
        if (response.status !== 200) {
          createCustomException({
            message: 'Não foi possível fazer o download do manual',
          })
        }

        downloadFile({
          local: { filename: 'Orientação-Geral-Movimentação-de-colaboradores.pdf', base64: response.data }
        })
      })
      .catch((error: Error) => {
        const { message } = getException(error)
        showModal({
          type: 'error',
          message: message || 'Houve um erro ao efetuar o download do manual',
          hideButtonCancel: true,
          txtButtonConfirm: 'OK',
        })
      })
      .finally(() => setLoading('idle'))
  }

  const handleDownloadOrientacaoContraparte = () => {
    setLoading('loading')

    ManuaisFornecedorService()
      .getManual('Manual-de-Operacao-do-Usuario-Contraparte.pdf')
      .then(response => {
        if (response.status !== 200) {
          createCustomException({
            message: 'Não foi possível fazer o download do manual',
          })
        }

        downloadFile({
          local: { filename: 'Manual-de-Operacão-do-Usuário-Contraparte.pdf', base64: response.data }
        })
      })
      .catch((error: Error) => {
        const { message } = getException(error)
        showModal({
          type: 'error',
          message: message || 'Houve um erro ao efetuar o download do manual',
          hideButtonCancel: true,
          txtButtonConfirm: 'OK',
        })
      })
      .finally(() => setLoading('idle'))
  }

  const handleIsExpanded = (contratoId: number) => {
    if (contratoId === selectedModalID || pesquisaMovFornecedorExpanded.findIndex(e => e.id === contratoId) !== -1) return true
    return false;
  }

  const getPesquisaMovFornecedorExpanded = useCallback(async () => {
    const expanded = await reportsDatabase.expandedCardsMovMensal.toArray()
    setPesquisaMovFornecedorExpanded(expanded)
  }, [setPesquisaMovFornecedorExpanded])

  useEffect(() => {
    getDadosParametrizacao()
    getPesquisaMovFornecedorExpanded()
  }, [])

  return (
    <MovMensalProvider>
      <Row
        marginTop={SPACING.spacing10}
        justifyContent="flex-end"
      >
        <Col>
          <Button
            text="Orientações Gerais de Movimentação Mensal de Colaboradores"
            variantButton="outlined"
            onClick={handleDownloadOrientacaoFornecedor}
            marginRight={SPACING.spacing20}
          />
          <Button
            marginTop={SPACING.spacing10}
            text="Orientações Gerais Manual de Operações do Contraparte"
            variantButton="outlined"
            onClick={handleDownloadOrientacaoContraparte}
            marginRight={SPACING.spacing20}
            hide={allDatadescripted?.Perfil === 'Fornecedor'}
          />
        </Col>
      </Row>
      <Tab tabs={tabs} value={selectedTab} handleChange={handleChange} />
      {selectedTab === 0 &&
        (allDatadescripted?.Perfil === 'Fornecedor' ||
          user.PerfilUsuarioId === PERMITIONS.CSNCONTRAPARTE) && (
          <PesquisaMovFornecedor
            parametrizacoes={parametrizacoes}
            handleChangeTab={handleCompetencia}
            setSelectedContratoID={setSelectedModalID}
            handleIsExpanded={handleIsExpanded}
          />
        )}
      {selectedTab === 0 &&
        [PERMITIONS.NGTANALISTA, PERMITIONS.NGTNORMATIVO].includes(
          user.PerfilUsuarioId
        ) && <PesquisaMovAnalista handleChangeTab={handleCompetencia} />}
      {selectedTab === 1 && (
        <MovimentacaoMensal
          handleCompetencia={handleCompetencia}
          handleTab={handleChange}
        />
      )}
    </MovMensalProvider>
  )
}

export default MovMensal
